// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Money40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Money40: FC<Money40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M18.653 35v-3.528c-1.546-.296-2.836-.912-3.868-1.847-1.033-.935-1.78-2.162-2.243-3.68l2.583-1.056c.454 1.333 1.113 2.333 1.98 3 .865.667 1.937 1 3.214 1 1.269 0 2.322-.308 3.16-.924.838-.616 1.257-1.493 1.257-2.632s-.356-2.025-1.07-2.66c-.712-.634-2.143-1.303-4.291-2.006-2.13-.676-3.671-1.54-4.625-2.59-.954-1.052-1.43-2.355-1.43-3.91 0-1.62.523-2.94 1.569-3.959 1.046-1.018 2.3-1.597 3.764-1.736V5h2.777v3.472c1.297.167 2.396.609 3.3 1.327a6.697 6.697 0 0 1 2.034 2.701l-2.584 1.111c-.37-.889-.875-1.542-1.513-1.958-.64-.417-1.487-.625-2.542-.625-1.26 0-2.245.284-2.958.854-.713.57-1.07 1.322-1.07 2.257 0 1.01.417 1.82 1.25 2.43.833.612 2.343 1.246 4.528 1.903 1.898.574 3.313 1.428 4.243 2.563.93 1.134 1.396 2.52 1.396 4.16 0 1.823-.537 3.263-1.611 4.319-1.074 1.055-2.565 1.727-4.473 2.014V35h-2.777Z" />
        </svg>
    );
};

export default Money40;
